import http from "@/core/services/http.service";

const ContractService = {
  sendContract(data) {
    return http.post('/api/v1/contracts/send/', data);
  },
  getContractPreviewURL(contractUuid) {
    return http.post(`/api/v1/contracts/preview-url/${contractUuid}/`);
  },
  resendContractDocument(contractUuid) {
    return http.post(`/api/v1/contracts/resend-document/${contractUuid}/`);
  },
  createContracts(formData, onUploadProgress) {
    return http.post('/api/v1/contracts/?expand=created_by', formData,
      {headers: {'Content-Type': 'multipart/form-data'}, onUploadProgress
      });
  },
  getContracts(params=null) {
    return http.get(`/api/v1/contracts/`, {params});
  },
  getContractFilePdf(contractFileUuid) {
    return http.post(`/api/v1/contracts/${contractFileUuid}/pdf-data/`);
  },
  deleteContract(uuid) {
    return http.delete(`/api/v1/contracts/${uuid}/`);
  },

  getContractPdf(uuid, objectName, fileType, data = {}) {
    return http.post(`/api/v1/contracts/${uuid}/${objectName}/${fileType}/contract-pdf-data/`, data);
  },
  uploadSignedPdfManually({formData, onUploadProgress}) {
    return http.post('/api/v1/contracts/?expand=created_by', formData,
      {headers: {'Content-Type': 'multipart/form-data'}, onUploadProgress
      });
  },
  contractSubmitSignature(uuid, data, objectName, fileType) {
    return http.post(`/api/v1/contracts/${uuid}/${objectName}/${fileType}/contract-signature-submit/`, data)
  },
  contractRegenerate(uuid, objectName, fileType, data) {
    return http.post(`/api/v1/contracts/${uuid}/${objectName}/${fileType}/contract-regenerate/`, data)
  },
  contractSubmitStaffSignature(uuid, objectName, fileType) {
    return http.post(`/api/v1/contracts/${uuid}/${objectName}/${fileType}/contract-staff-signature-submit/`)
  },
  partialUpdateContract(payload) {
    return http.patch(`/api/v1/contracts/${payload.uuid}/`, payload.data);
  },
  async onFileSend(vm, contract, source, successCallback = null) {
    let success = await vm.$confirm(vm.$i18n.t('Are you sure you want to send following contract?'))

    if (!success) return;

    if (vm.isDocusignEnabled) {
      vm.showContractSendModal({
        contract: contract,
        source: source
      })
    } else {
      let data = {'contract_uuid': contract.uuid}

      let response = await ContractService.sendContract(data);
      if (response.success) {
        if (successCallback) {
          successCallback()
        }
        vm.$toast('success', vm.$i18n.t('Contract was successfully sent'));
      } else {
        if (response.body.non_field_errors) {
          vm.$errorDialog(response.body.non_field_errors[0]);
        } else {
          vm.$errorDialog(vm.$i18n.t('Something went wrong'));
        }
      }
    }
  },
  async onFileResend(vm, contract) {
    let success = await vm.$confirm(vm.$i18n.t('Are you sure you want to resend following contract?'))
    if (!success) return;

    let response = await ContractService.resendContractDocument(contract.uuid)
    if (response.success) {
      vm.$toast('success', vm.$i18n.t('Contract was successfully sent'));
    } else {
      if (response.body.non_field_errors) {
        vm.$errorDialog(response.body.non_field_errors[0]);
      } else {
        vm.$errorDialog(vm.$i18n.t('Error occurred while resending contract. Please, try again later.'));
      }
    }
  },
  isThirdPartyPlatform(contract) {
    return contract && ['docusign'].includes(contract.signature_platform)

  }
}

export default ContractService;
